// extracted by mini-css-extract-plugin
export var menuItem = "z_tF d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "z_tG d_Z d_bz d_bP";
export var menuMainLink = "z_tH d_f0 d_dB";
export var menuLink = "z_tJ d_f0 d_dB";
export var icon = "z_p9 d_bC d_bP";
export var divider = "z_tK d_bC d_bP";
export var sublinks = "z_tL";
export var link = "z_mC";
export var Link = "z_tb y_tb y_sw y_sR";